<template>
    <div id="splashback">
        <div id="splash">
            <center>
                <img id="splash" src="/assets/splash.png" alt="SecondOeuvre" />
            </center>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Splash',
        data() {
            return {};
        },
        methods: {
            getCookies: function() {
                if(this.$cookie.get('jwt') && this.$cookie.get('role')){
                    this.$router.replace({ name: "home" });
                }
                else{
                    this.$router.replace({ name: "login" });
                }
            }
        },
        mounted(){
            var vm = this;
            setTimeout(function(){
               vm.getCookies();
            }, 500);
        }
    }
</script>

<style scoped>
    #splash {
        background-color: #2b2b2b;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #splashback {
        background-color:#2b2b2b;
        width:100%;
        height:100vh;
        margin: auto;
    }
    html, body {
        background-color: #2b2b2b !important;
        width: 100%;
        height: 100% !important;
        margin: auto;
        margin-top: 0px;
        margin-bottom: 0px;
        padding: 0px;
    }
</style>